import { render, staticRenderFns } from "./PaymentFinished.vue?vue&type=template&id=0d2fe734&scoped=true&"
import script from "./PaymentFinished.vue?vue&type=script&lang=js&"
export * from "./PaymentFinished.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFinished.vue?vue&type=style&index=0&id=0d2fe734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fe734",
  null
  
)

export default component.exports